import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../../mp-core/themes/palette"

export type StylesProperties =
  | "radioGroup"
  | "label"
  | "radio"
  | "passwordContainer"
  | "passwordInput"

export const useStyles = makeStyles()(({ spacing }) => ({
  radioGroup: {
    gap: spacing(3)
  },
  label: {
    margin: 0,
    gap: spacing(3)
  },
  radio: {
    padding: 0,
    color: blueGrey[300],

    "&.Mui-checked": {
      color: lightBlue[500]
    }
  },
  passwordContainer: {
    display: "flex",
    marginLeft: spacing(4)
  },
  passwordInput: {
    marginLeft: spacing(3)
  }
}))
